import {
  API_get_actual_schedule,
  API_get_actual_schedule_labor_deployment,
  API_get_copilot_schedule,
  API_get_forecasted_labor,
  API_get_intraday_metrics,
} from "../../../constants";

const SHIFT_MUTATION_REFRESH_ENTRIES = [
  [API_get_actual_schedule, "actual_schedule"],
  [API_get_copilot_schedule, "copilot_schedule"],
  [
    API_get_actual_schedule_labor_deployment,
    "actual_schedule_labor_deployment",
  ],
  [API_get_intraday_metrics, "intraday_metrics"],
  [API_get_forecasted_labor, "forecasted_labor"],
];

// Shift edits affect the draft schedule and schedule-derived labor data. Keep
// unrelated published-schedule and guest-review data in the broader refresh
// bundle used by workflows that can actually change those resources.
export const SHIFT_MUTATION_REFRESH_API_CALLS =
  SHIFT_MUTATION_REFRESH_ENTRIES.map(([api]) => api);

export const SHIFT_MUTATION_REFRESH_DATA_NAMES =
  SHIFT_MUTATION_REFRESH_ENTRIES.map(([, dataName]) => dataName);
